import { render, staticRenderFns } from "./OturumLimitiDialog.vue?vue&type=template&id=6606c8e7&scoped=true"
import script from "./OturumLimitiDialog.vue?vue&type=script&lang=ts"
export * from "./OturumLimitiDialog.vue?vue&type=script&lang=ts"
import style0 from "./OturumLimitiDialog.vue?vue&type=style&index=0&id=6606c8e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6606c8e7",
  null
  
)

export default component.exports